import { TutorialModule } from '../types';
import { TUTORIAL_STRINGS, TUTORIAL_METADATA } from './tutorialStrings';

export const TUTORIAL_MODULES: TutorialModule[] = [
  {
    id: 'introduction',
    title: TUTORIAL_METADATA.introduction.title,
    description: TUTORIAL_METADATA.introduction.description,
    steps: [
      {
        id: 'welcome',
        message: TUTORIAL_STRINGS.welcome_message,
        targetId: 'pose-save-to-frame-container',
        actionRequired: 'addKeyframe'
      },
      {
        id: 'select-frame',
        message: TUTORIAL_STRINGS.step2_message,
        targetId: 'timeline-frame-1.000',
        actionRequired: 'selectFrame',
        targetValue: '1.0'
      },
      {
        id: 'select-left-shoulder',
        message: TUTORIAL_STRINGS.step3_message,
        targetId: 'tutorial-3d-target',
        actionRequired: 'selectJoint',
        targetValue: 'leftShoulder'
      },
      {
        id: 'rotate-shoulder-z',
        message: TUTORIAL_STRINGS.step4_message,
        targetId: 'joint-slider-leftShoulder-Z',
        actionRequired: 'rotateJoint',
        targetValue: '180'
      },
      {
        id: 'save-pose-2',
        message: TUTORIAL_STRINGS.step5_message,
        targetId: 'pose-save-to-frame-container',
        actionRequired: 'addKeyframe'
      },
      {
        id: 'select-frame-2',
        message: TUTORIAL_STRINGS.step6_message,
        targetId: 'timeline-frame-2.500',
        actionRequired: 'selectFrame',
        targetValue: '2.5'
      },
      {
        id: 'rotate-shoulder-mouse',
        message: TUTORIAL_STRINGS.step7_message,
        targetId: 'tutorial-3d-target',
        actionRequired: 'rotateJointMouse',
        targetValue: 'leftShoulder'
      },
      {
        id: 'save-final-pose',
        message: TUTORIAL_STRINGS.step8_message,
        targetId: 'pose-save-to-frame-container',
        actionRequired: 'addKeyframe'
      },
      {
        id: 'select-start',
        message: TUTORIAL_STRINGS.step9_message,
        targetId: 'timeline-frame-0.000',
        actionRequired: 'selectFrame',
        targetValue: '0.0'
      },
      {
        id: 'play-sequence',
        message: TUTORIAL_STRINGS.step10_message,
        targetId: 'timeline-play-pause',
        actionRequired: 'playSequence'
      },
      {
        id: 'stop-sequence',
        message: TUTORIAL_STRINGS.step11_message,
        targetId: 'timeline-play-pause',
        actionRequired: 'stopSequence'
      },
      {
        id: 'save-sequence',
        message: TUTORIAL_STRINGS.step12_message,
        targetId: 'timeline-save-sequence',
        actionRequired: 'saveSequence'
      },
      {
        id: 'conclusion',
        message: TUTORIAL_STRINGS.step13_message,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'posing',
    title: TUTORIAL_METADATA.posing.title,
    description: TUTORIAL_METADATA.posing.description,
    steps: [
      {
        id: 'stage-orientations',
        message: TUTORIAL_STRINGS.module2_step1,
        targetId: '',
        supportingTargetId: 'tutorial-target-green-orb, tutorial-target-audience-arrow',
        actionRequired: 'next'
      },
      {
        id: 'view-controls',
        message: TUTORIAL_STRINGS.module2_step2,
        targetId: '',
        actionRequired: 'next',
        showVisual: 'viewControls'
      },

      {
        id: 'adv-toggle-labels',
        message: TUTORIAL_STRINGS.posing_labels,
        targetId: 'tutorial-toggle-labels',
        actionRequired: 'toggleLabels'
      },
      {
        id: 'adv-labels-explanation',
        message: TUTORIAL_STRINGS.posing_labels_explanation,
        targetId: 'tutorial-3d-target',
        targetValue: 'leftShoulder',
        actionRequired: 'next'
      },
      {
        id: 'adv-mirror-mode',
        message: TUTORIAL_STRINGS.posing_mirror_mode,
        targetId: 'tutorial-mirror-mode',
        actionRequired: 'toggleMirror'
      },
      {
        id: 'adv-move-asymmetric',
        message: TUTORIAL_STRINGS.posing_asymmetry,
        targetId: 'tutorial-3d-target',
        targetValue: 'leftShoulder',
        actionRequired: 'rotateJointMouse'
      },
      {
        id: 'adv-mirror-flip',
        message: TUTORIAL_STRINGS.posing_mirror_flip,
        targetId: 'tutorial-mirror-flip',
        actionRequired: 'mirrorFlip'
      },
      {
        id: 'adv-reflect',
        message: TUTORIAL_STRINGS.posing_reflect,
        targetId: 'tutorial-reflect-joint',
        actionRequired: 'reflectJoint'
      },
      {
        id: 'adv-toggle-axes',
        message: TUTORIAL_STRINGS.posing_toggle_axes,
        targetId: 'tutorial-toggle-axes',
        actionRequired: 'toggleAxes'
      },
      {
        id: 'adv-reset-joint',
        message: TUTORIAL_STRINGS.posing_reset_joint,
        targetId: 'tutorial-reset-joint',
        targetValue: 'rightShoulder',
        actionRequired: 'resetJoint'
      },
      {
        id: 'adv-reset-pose',
        message: TUTORIAL_STRINGS.posing_reset_pose,
        targetId: 'tutorial-reset-pose',
        actionRequired: 'resetPose'
      },
      {
        id: 'adv-conclusion',
        message: TUTORIAL_STRINGS.posing_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'advanced-posing',
    title: TUTORIAL_METADATA.advanced_posing.title,
    description: TUTORIAL_METADATA.advanced_posing.description,
    steps: [
      {
        id: 'adv-torso-intro',
        message: TUTORIAL_STRINGS.advanced_posing_torso_intro,
        targetId: 'joint-slider-torso-T, joint-slider-torso-L, joint-slider-torso-V',
        actionRequired: 'next'
      },
      {
        id: 'adv-torso-t',
        message: TUTORIAL_STRINGS.advanced_posing_torso_t,
        targetId: 'joint-slider-torso-T',
        actionRequired: 'changeTorsoT'
      },
      {
        id: 'adv-torso-v',
        message: TUTORIAL_STRINGS.advanced_posing_torso_v,
        targetId: 'joint-slider-torso-V',
        actionRequired: 'changeTorsoV'
      },
      {
        id: 'adv-torso-l',
        message: TUTORIAL_STRINGS.advanced_posing_torso_l,
        targetId: 'joint-slider-torso-L',
        actionRequired: 'changeTorsoL'
      },
      {
        id: 'adv-drag-relationship-intro',
        message: TUTORIAL_STRINGS.advanced_posing_drag_relationship_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'adv-drag-select-elbow',
        message: TUTORIAL_STRINGS.advanced_posing_drag_select_elbow,
        targetId: 'tutorial-3d-target',
        targetValue: 'leftElbow',
        actionRequired: 'selectJoint'
      },
      {
        id: 'adv-drag-elbow-drag',
        message: TUTORIAL_STRINGS.advanced_posing_drag_elbow_drag,
        targetId: 'tutorial-3d-target',
        targetValue: 'leftElbow',
        actionRequired: 'rotateJointMouse'
      },
      {
        id: 'adv-torso-conclusion',
        message: TUTORIAL_STRINGS.advanced_posing_torso_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'locations-markers',
    title: TUTORIAL_METADATA.locations_markers.title,
    description: TUTORIAL_METADATA.locations_markers.description,
    steps: [
      {
        id: 'mark-location',
        message: TUTORIAL_STRINGS.module2_mark_location,
        targetId: 'tutorial-mark-location',
        actionRequired: 'addLocationMarker'
      },
      {
        id: 'mark-foot',
        message: TUTORIAL_STRINGS.module2_mark_foot,
        targetId: 'tutorial-mark-foot',
        actionRequired: 'addFootMarker'
      },
      {
        id: 'mark-location-shortcut',
        message: TUTORIAL_STRINGS.module2_mark_location_shortcut,
        targetId: 'tutorial-location-click-target',
        actionRequired: 'addLocationMarker'
      },
      {
        id: 'snap-to-marker',
        message: TUTORIAL_STRINGS.module2_snap_marker,
        targetId: 'tutorial-snap-location-marker',
        actionRequired: 'snapToMarker'
      },
      {
        id: 'clear-all-markers',
        message: TUTORIAL_STRINGS.module2_clear_markers,
        targetId: 'tutorial-clear-all-markers',
        actionRequired: 'clearAllMarkers'
      },
      {
        id: 'locations-markers-conclusion',
        message: TUTORIAL_STRINGS.locations_markers_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'attitudes',
    title: TUTORIAL_METADATA.attitudes.title,
    description: TUTORIAL_METADATA.attitudes.description,
    steps: [
      {
        id: 'orientation-control',
        message: TUTORIAL_STRINGS.module2_step3,
        targetId: 'tutorial-orientation-control',
        actionRequired: 'next'
      },
      {
        id: 'vertical-attitude-select',
        message: TUTORIAL_STRINGS.module2_step4,
        targetId: 'tutorial-3d-target',
        targetValue: 'orientation',
        actionRequired: 'selectJoint'
      },
      {
        id: 'vertical-attitude-rotate',
        message: TUTORIAL_STRINGS.module2_step5,
        targetId: 'tutorial-3d-target',
        targetValue: 'orientation',
        actionRequired: 'rotateJointMouse'
      },
      {
        id: 'vertical-attitude-move',
        message: TUTORIAL_STRINGS.module2_step7,
        targetId: 'tutorial-3d-target',
        targetValue: 'orientation',
        actionRequired: 'moveFloorMouse'
      },
      {
        id: 'vertical-attitude-conical',
        message: TUTORIAL_STRINGS.module2_step6,
        targetId: 'tutorial-3d-target',
        targetValue: 'orientation',
        actionRequired: 'rotateConicalMouse'
      },
      {
        id: 'torso-rotation',
        message: TUTORIAL_STRINGS.module2_torso_rotation,
        targetId: 'tutorial-3d-target',
        targetValue: 'orientation',
        actionRequired: 'rotateTorsoMouse'
      },
      {
        id: 'vertical-attitude-reset',
        message: TUTORIAL_STRINGS.module2_step8,
        targetId: 'tutorial-reset-orientation',
        targetValue: 'orientation',
        actionRequired: 'resetJoint'
      },
      {
        id: 'vertical-height-control',
        message: TUTORIAL_STRINGS.module2_step9,
        targetId: 'tutorial-height-control',
        actionRequired: 'changeElevation'
      },
      {
        id: 'ground-mannequin',
        message: TUTORIAL_STRINGS.module2_step10,
        targetId: 'tutorial-ground-button',
        actionRequired: 'groundMannequin'
      },
      {
        id: 'module2-conclusion',
        message: TUTORIAL_STRINGS.module2_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },

  {
    id: 'designing-sequences-no-music',
    title: TUTORIAL_METADATA.designing_sequences_no_music.title,
    description: TUTORIAL_METADATA.designing_sequences_no_music.description,
    steps: [
      {
        id: 'seq-intro',
        message: TUTORIAL_STRINGS.module4_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'seq-change-duration',
        message: TUTORIAL_STRINGS.module4_change_duration,
        targetId: 'timeline-duration-input',
        actionRequired: 'changeDuration'
      },
      {
        id: 'seq-change-interval',
        message: TUTORIAL_STRINGS.module4_change_interval,
        targetId: 'timeline-tick-interval-select',
        actionRequired: 'changeTickInterval'
      },
      {
        id: 'seq-zoom',
        message: TUTORIAL_STRINGS.module4_zoom,
        targetId: 'timeline-zoom-in-btn, timeline-zoom-out-btn, timeline-zoom-reset-btn',
        actionRequired: 'next'
      },
      {
        id: 'seq-compact',
        message: TUTORIAL_STRINGS.module4_compact,
        targetId: 'timeline-compact-toggle-btn',
        actionRequired: 'toggleCompact'
      },
      {
        id: 'seq-expand',
        message: TUTORIAL_STRINGS.module4_expand,
        targetId: 'timeline-compact-toggle-btn',
        actionRequired: 'toggleCompact'
      },
      {
        id: 'seq-navigation',
        message: TUTORIAL_STRINGS.module4_navigation,
        targetId: 'timeline-jump-start-btn, timeline-prev-page-btn, timeline-prev-pose-btn, timeline-next-pose-btn, timeline-next-page-btn, timeline-jump-end-btn',
        actionRequired: 'next'
      },
      {
        id: 'seq-add-dot',
        message: TUTORIAL_STRINGS.module4_add_dot,
        targetId: 'timeline-dot-1.000-0, timeline-dot-1.000-1, timeline-dot-1.000-2, timeline-dot-1.000-3',
        actionRequired: 'toggleFrameMarker'
      },
      {
        id: 'seq-conclusion-part1',
        message: TUTORIAL_STRINGS.module4_conclusion_part1,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'quick-editing-timeline',
    title: TUTORIAL_METADATA.quick_editing_timeline.title,
    description: TUTORIAL_METADATA.quick_editing_timeline.description,
    steps: [
      {
        id: 'quick-edit-intro',
        message: TUTORIAL_STRINGS.quick_edit_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'seq-move-keyframe',
        message: TUTORIAL_STRINGS.module4_move_keyframe,
        targetId: 'timeline-frame-1.000',
        actionRequired: 'moveKeyframe'
      },
      {
        id: 'seq-copy-keyframe',
        message: TUTORIAL_STRINGS.module4_copy_keyframe,
        targetId: 'timeline-frame-2.000',
        actionRequired: 'copyKeyframe'
      },
      {
        id: 'seq-select-multi',
        message: TUTORIAL_STRINGS.module4_select_multi,
        targetId: 'timeline-track-scroll',
        actionRequired: 'selectMultipleFrames'
      },
      {
        id: 'seq-move-multi',
        message: TUTORIAL_STRINGS.module4_move_multi,
        targetId: 'timeline-track-scroll',
        actionRequired: 'moveMultipleFrames'
      },
      {
        id: 'seq-clear-timeline',
        message: TUTORIAL_STRINGS.module4_clear_timeline,
        targetId: 'timeline-clear-btn',
        actionRequired: 'clearTimeline'
      },
      {
        id: 'seq-conclusion',
        message: TUTORIAL_STRINGS.module4_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'designing-sequences-with-music',
    title: TUTORIAL_METADATA.designing_sequences_with_music.title,
    description: TUTORIAL_METADATA.designing_sequences_with_music.description,
    steps: [
      {
        id: 'seq-music-intro',
        message: TUTORIAL_STRINGS.module5_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'seq-music-load',
        message: TUTORIAL_STRINGS.module5_load,
        targetId: 'timeline-soundtrack-btn',
        actionRequired: 'click'
      },
      {
        id: 'seq-music-options',
        message: TUTORIAL_STRINGS.module5_options,
        targetId: 'soundtrack-modal-cancel-btn',
        supportingTargetId: 'soundtrack-modal-url-row, soundtrack-modal-drop-zone',
        actionRequired: 'click'
      },
      {
        id: 'seq-music-waveform',
        message: TUTORIAL_STRINGS.module5_waveform,
        targetId: 'timeline-waveform-canvas',
        actionRequired: 'next'
      },
      {
        id: 'seq-music-grid',
        message: TUTORIAL_STRINGS.module5_grid,
        targetId: 'timeline-waveform-canvas',
        actionRequired: 'next'
      },
      {
        id: 'seq-music-dot',
        message: TUTORIAL_STRINGS.module5_dot,
        targetId: 'timeline-measure-dot-2.000',
        actionRequired: 'next'
      },
      {
        id: 'seq-music-subdivision',
        message: TUTORIAL_STRINGS.module5_subdivision,
        targetId: 'timeline-tick-interval-select',
        actionRequired: 'changeBeatSubdivision'
      },
      {
        id: 'seq-music-subdivision-effect',
        message: TUTORIAL_STRINGS.module5_subdivision_effect,
        targetId: 'timeline-waveform-canvas',
        actionRequired: 'next'
      },
      {
        id: 'seq-music-conclusion',
        message: TUTORIAL_STRINGS.module5_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'notes-annotations',
    title: TUTORIAL_METADATA.notes_annotations.title,
    description: TUTORIAL_METADATA.notes_annotations.description,
    steps: [
      {
        id: 'notes-intro',
        message: TUTORIAL_STRINGS.notes_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'notes-write-pose-note',
        message: TUTORIAL_STRINGS.notes_write_pose_note,
        targetId: 'sidebar-notes-textarea',
        actionRequired: 'writePoseNote'
      },
      {
        id: 'notes-save-pose-note',
        message: TUTORIAL_STRINGS.notes_save_pose_note,
        targetId: 'pose-save-to-frame-container',
        actionRequired: 'savePoseNote'
      },
      {
        id: 'notes-create-frame-note',
        message: TUTORIAL_STRINGS.notes_create_frame_note,
        targetId: 'timeline-frame-4.000',
        actionRequired: 'openFrameNoteInput'
      },
      {
        id: 'notes-write-frame-note',
        message: TUTORIAL_STRINGS.notes_write_frame_note,
        targetId: 'keyframe-note-save-btn',
        actionRequired: 'saveFrameNote'
      },
      {
        id: 'notes-hover-tooltip',
        message: TUTORIAL_STRINGS.notes_hover_tooltip,
        targetId: 'timeline-frame-4.000',
        actionRequired: 'hoverFrame'
      },
      {
        id: 'notes-edit-tooltip',
        message: TUTORIAL_STRINGS.notes_edit_tooltip,
        targetId: 'timeline-dot-0.000-1, timeline-dot-4.000-2',
        actionRequired: 'next'
      },
      {
        id: 'notes-conclusion',
        message: TUTORIAL_STRINGS.notes_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'library-management',
    title: TUTORIAL_METADATA.library_management.title,
    description: TUTORIAL_METADATA.library_management.description,
    steps: [
      {
        id: 'lib-intro',
        message: TUTORIAL_STRINGS.module6_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'lib-switch-tab',
        message: TUTORIAL_STRINGS.module6_switch_tab,
        targetId: 'nav-poses-tab',
        actionRequired: 'switchTab',
        targetValue: 'Poses'
      },
      {
        id: 'lib-create-folder',
        message: TUTORIAL_STRINGS.module6_create_folder,
        targetId: 'library-folder-default-poses',
        actionRequired: 'next'
      },
      {
        id: 'lib-load-pose',
        message: TUTORIAL_STRINGS.module6_load_pose,
        targetId: 'library-first-pose-card',
        actionRequired: 'next'
      },
      {
        id: 'lib-drag-drop',
        message: TUTORIAL_STRINGS.module6_drag_drop,
        targetId: 'library-first-pose-card',
        actionRequired: 'next'
      },
      {
        id: 'lib-advanced-ops',
        message: TUTORIAL_STRINGS.module6_advanced_ops,
        targetId: 'library-first-pose-card',
        actionRequired: 'next'
      },
      {
        id: 'lib-switch-sequences',
        message: TUTORIAL_STRINGS.module6_switch_sequences,
        targetId: 'nav-sequences-tab',
        actionRequired: 'switchTab',
        targetValue: 'Sequences'
      },
      {
        id: 'lib-conclusion',
        message: TUTORIAL_STRINGS.module6_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'context-shortcuts',
    title: TUTORIAL_METADATA.context_shortcuts.title,
    description: TUTORIAL_METADATA.context_shortcuts.description,
    steps: [
      {
        id: 'shortcuts-intro',
        message: TUTORIAL_STRINGS.shortcuts_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'shortcuts-stage',
        message: TUTORIAL_STRINGS.shortcuts_stage,
        targetId: 'stage-3d-container',
        actionRequired: 'next'
      },
      {
        id: 'shortcuts-joint',
        message: TUTORIAL_STRINGS.shortcuts_joint,
        targetId: 'tutorial-3d-target',
        targetValue: 'leftShoulder',
        actionRequired: 'next'
      },
      {
        id: 'shortcuts-timeline',
        message: TUTORIAL_STRINGS.shortcuts_timeline,
        targetId: 'timeline-frame-0.000',
        actionRequired: 'next'
      },
      {
        id: 'shortcuts-folders',
        message: TUTORIAL_STRINGS.shortcuts_folders,
        targetId: 'library-folder-default-poses',
        actionRequired: 'next'
      },
      {
        id: 'shortcuts-library',
        message: TUTORIAL_STRINGS.shortcuts_library,
        targetId: 'library-first-pose-card',
        actionRequired: 'next'
      },
      {
        id: 'shortcuts-conclusion',
        message: TUTORIAL_STRINGS.shortcuts_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'workspace-mastery',
    title: TUTORIAL_METADATA.workspace_mastery.title,
    description: TUTORIAL_METADATA.workspace_mastery.description,
    steps: [
      {
        id: 'wm-intro',
        message: TUTORIAL_STRINGS.wm_intro,
        targetId: '',
        actionRequired: 'next'
      },
      {
        id: 'wm-undo-redo',
        message: TUTORIAL_STRINGS.wm_undo_redo,
        targetId: 'sidebar-undo-btn, sidebar-redo-btn',
        actionRequired: 'next'
      },
      {
        id: 'wm-auto-save',
        message: TUTORIAL_STRINGS.wm_auto_save,
        targetId: 'sidebar-auto-save-checkbox',
        actionRequired: 'next'
      },
      {
        id: 'wm-confirm-reset',
        message: TUTORIAL_STRINGS.wm_confirm_reset,
        targetId: 'sidebar-confirm-reset-checkbox',
        actionRequired: 'next'
      },
      {
        id: 'wm-scroll-rotation',
        message: TUTORIAL_STRINGS.wm_scroll_rotation,
        targetId: 'tutorial-3d-target',
        targetValue: 'rightShoulder',
        actionRequired: 'next',
        showVisual: 'scrollRotation'
      },
      {
        id: 'wm-random-pose',
        message: TUTORIAL_STRINGS.wm_random_pose,
        targetId: 'timeline-random-pose-btn',
        actionRequired: 'next'
      },
      {
        id: 'wm-randomness',
        message: TUTORIAL_STRINGS.wm_randomness,
        targetId: 'timeline-randomness-slider-container',
        actionRequired: 'next'
      },
      {
        id: 'wm-new-sequence',
        message: TUTORIAL_STRINGS.wm_new_sequence,
        targetId: 'nav-new-sequence-btn',
        actionRequired: 'next'
      },
      {
        id: 'wm-import-export',
        message: TUTORIAL_STRINGS.wm_import_export,
        targetId: 'nav-import-export-container',
        actionRequired: 'next'
      },
      {
        id: 'wm-conclusion',
        message: TUTORIAL_STRINGS.wm_conclusion,
        targetId: 'top-menu-tutorial',
        actionRequired: 'none'
      }
    ]
  },
  {
    id: 'using-choreoverse',
    title: TUTORIAL_METADATA.using_choreoverse.title,
    description: TUTORIAL_METADATA.using_choreoverse.description,
    steps: []
  },
  {
    id: 'designing-poses-ai',
    title: TUTORIAL_METADATA.designing_poses_ai.title,
    description: TUTORIAL_METADATA.designing_poses_ai.description,
    steps: []
  },
  {
    id: 'designing-sequences-ai',
    title: TUTORIAL_METADATA.designing_sequences_ai.title,
    description: TUTORIAL_METADATA.designing_sequences_ai.description,
    steps: []
  },
  {
    id: 'sharing-collaborating',
    title: TUTORIAL_METADATA.sharing_collaborating.title,
    description: TUTORIAL_METADATA.sharing_collaborating.description,
    steps: []
  },
  {
    id: 'showcasing-monetization',
    title: TUTORIAL_METADATA.showcasing_monetization.title,
    description: TUTORIAL_METADATA.showcasing_monetization.description,
    steps: []
  }
];
